<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        Empresa especializada en el desarrollo de software web.
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Veccit DevOps</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-facebook",
        link: "https://www.facebook.com/edward.martinez.7564/",
      },
      {
        text: "mdi-youtube",
        link: "https://www.youtube.com/channel/UC47nheHQBCBGHPKFVOAriHA",
      },
      {
        text: "mdi-linkedin",
        link: "https://www.linkedin.com/in/eduar-enrique-martinez-chirinos-0003011a4/",
      },
      {
        text: "mdi-instagram",
        link: "https://www.instagram.com/veccitdevops/",
      },
      {
        text:"mdi-twitch",
        link:"https://www.twitch.tv/mr_e_emch",
      }
    ],
  }),
};
</script>
